import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const CircleHalf = createSvgIcon(
  () => (
    <path d="M35 20C35 11.7188 28.2812 5 20 5V35C28.2812 35 35 28.2812 35 20ZM0 20C0 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20C40 25.3043 37.8929 30.3914 34.1421 34.1421C30.3914 37.8929 25.3043 40 20 40C14.6957 40 9.60859 37.8929 5.85786 34.1421C2.10714 30.3914 0 25.3043 0 20Z" />
  ),
  '0 0 40 40'
);
